/**
 * True if a stored URL is safe to put in an iframe src or a link href:
 * http(s), or relative to the page. javascript:, data: and the like would
 * run script in the viewer's session. The server refuses these on save; this
 * covers anything stored before it did.
 *
 * @param {String} url        The URL to check.
 * @param {Array}  protocols  The schemes to allow.
 * @returns {Boolean}
 */
export const isSafeUrl = (url, protocols = ['http:', 'https:']) => {
	if (typeof url !== 'string') {
		return false;
	}

	try {
		return protocols.includes(new URL(url, window.location.href).protocol);
	} catch (error) {
		return false;
	}
};
